// ReminderPrompt — po uložení nového návyku/výzvy ponúkne pripomienku (v2).
// Zobrazí sa len keď pripomienka ešte nie je nastavená; Nastaviť → PATCH
// /api/tasks/<taskId> remind_at ("HH:MM" — denné upozornenie, kým nie je splnené).
import { useState } from "react";
import { api } from "../../lib/api";
import { st } from "../../styles.js";
import { Modal } from "../ui";
import { Select, Button } from "../ui/ds";

export function ReminderPrompt({ taskId, label, onClose }) {
  const [hh, setHh] = useState("08");
  const [mm, setMm] = useState("00");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const mins = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));
  async function save() {
    setBusy(true); setErr("");
    try { await api("/api/tasks/" + taskId, { method: "PATCH", body: { remind_at: hh + ":" + mm } }); onClose(true); }
    catch (e) { setErr((e && e.message) || "Nepodarilo sa uložiť."); setBusy(false); }
  }
  return (
    <Modal center title="Pripomenúť ti to?" icon="bell" maxWidth={360} onClose={() => onClose(false)}>
      <div style={{ fontSize: 14, lineHeight: 1.5, color: "var(--text)" }}>
        {label ? <>Chceš, aby ti Buzerlístok denne pripomenul <strong>{label}</strong>?</> : "Chceš denné pripomenutie?"}
        {" "}Upozornenie príde, len kým to v ten deň nie je splnené.
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14 }}>
        <Select value={hh} style={{ width: 96, fontSize: 16 }} aria-label="Hodina" onChange={(e) => setHh(e.target.value)}>
          {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")).map((h) => <option key={h} value={h}>{h}</option>)}
        </Select>
        <span style={{ fontWeight: 700, color: "var(--muted)" }}>:</span>
        <Select value={mm} style={{ width: 96, fontSize: 16 }} aria-label="Minúta" onChange={(e) => setMm(e.target.value)}>
          {mins.map((m) => <option key={m} value={m}>{m}</option>)}
        </Select>
      </div>
      {err && <div style={{ ...st.err, marginTop: 10 }}>{err}</div>}
      {/* stack (nie vedľa seba): dlhý label „Nastaviť pripomienku" + nowrap by na malom
          zariadení pretiekol mimo obrazovky */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 16 }}>
        <Button variant="primary" block type="button" disabled={busy} onClick={save}>{busy ? "…" : "Nastaviť pripomienku"}</Button>
        <Button variant="ghost" block type="button" onClick={() => onClose(false)}>Preskočiť</Button>
      </div>
    </Modal>
  );
}
